/** @format */

import React, { PureComponent } from 'react';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import MvnoBlockRequestState from '../../../interfaces/platform/MvnoBlockRequestState';
import { MvnoBlockFunctionsCollection } from '../../../modules/block/BlockContainHelper';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import MvnoBlockContain from '../../../interfaces/platform/MvnoBlockContain';
import MvnoBlockFunction from '../../../interfaces/platform/MvnoBlockFunction';
import DefaultCalledView from '../../Block/Function/DefaultCalledView';
import ErrorCalledView from '../../Block/Function/ErrorCalledView';
import FinishCalledView from '../../Block/Function/FinishCalledView';
import MvnoBlockRequest from '../../../interfaces/platform/MvnoBlockRequest';

interface BlockRequestStateListItemProps {
    dispatch: any;
    classes: any;
    mvnoBlockRequest: MvnoBlockRequest;
    mvnoBlockRequestState: MvnoBlockRequestState;
    blockFunctionList: MvnoBlockFunctionsCollection;
    containFunctions: Array<MvnoBlockContain>;

    viewDialog(title: any | string | null, content: any | null): void;
}

class BlockRequestStateListItem extends PureComponent<BlockRequestStateListItemProps> {
    getFunctionCalledView = (
        mvnoBlockFunctionId: number,
        containFunctions: Array<MvnoBlockFunction>,
        stateBlock: MvnoBlockRequestState
    ): object | null => {
        const { viewDialog, mvnoBlockRequest } = this.props;
        let func: MvnoBlockFunction | null = null;
        for (let i = 0; i < containFunctions.length; i++) {
            if (containFunctions[i].id === mvnoBlockFunctionId) {
                func = containFunctions[i];
                break;
            }
        }
        if (func === null) {
            return null;
        }
        switch (func.functionName) {
            case 'Adescom\\Block\\Finish':
                return <FinishCalledView blockFunction={func} stateBlock={stateBlock} />;
            case 'Adescom\\Block\\Error':
                return <ErrorCalledView blockFunction={func} stateBlock={stateBlock} />;
            default:
                return <DefaultCalledView blockFunction={func} stateBlock={stateBlock} viewDialog={viewDialog} mvnoBlockRequest={mvnoBlockRequest} />;
        }
    };

    render(): React.ReactNode {
        const { mvnoBlockRequestState, blockFunctionList } = this.props;
        let block: object | null = null;
        if (blockFunctionList['hydra:member']) {
            block = this.getFunctionCalledView(mvnoBlockRequestState.mvnoBlockFunctionId, blockFunctionList['hydra:member'], mvnoBlockRequestState);
        }
        return (
            <GridContainer>
                <GridItem xs={12}>{block}</GridItem>
            </GridContainer>
        );
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(adescomStyle)
)(BlockRequestStateListItem);
